import React from 'react';

const HomeButton = ({handleClick}) => {
    return <button onClick={handleClick} className='unclicked tabButton'>Home</button>
}

export default HomeButton;